import { useForm } from "react-hook-form";
import LabeledTextField from "../mui-components/LabeledTextField";
import { useSnapshot } from "valtio";
import { configStore, dataListStore, multiSelectListStore } from "../state/CommonState";
import Utils from "../util/Utils";
import { useEffect, useState } from "react";
import { AgMultiSelectWithCheckBoxes } from "../components/AgCustomComponents";
import { getStaticConsolidatorList } from "../StaticData";
import { isArray } from "lodash";
import { AgSelectNewCH } from "../components/AgCustlist";
import Api from "../state/Api";
import { AgUnlocCH } from "../components/AgComponents";
import { editStore } from "./editStore";

export default function EditSchedule(props) {
    let setOpenScheduleModel = props.setOpenScheduleModel
    let routes = props.routes
    useSnapshot(editStore)
    useSnapshot(configStore)
    useSnapshot(multiSelectListStore);
    useSnapshot(dataListStore)
    const selectedConsolidatorList = getStaticConsolidatorList();
    const consolidatorListKey = "consolidatorList";
     
    let s = editStore.schedule
    const cargoForm = useForm({
        defaultValues: {
            por:s.por,
            pol:s.pol,
            pod:s.pod,
            fpod:s.fpod,
            cutoffpor:s.cutoffpor,
            etdpol:s.etdpol,
            etapod:s.etapod,
            etafpod:s.etafpod,
            vesselname:s.vesselname,
            voyage:s.voyage,
            carrier:s.carrier,
            transittime:s.transittime,
            coloader:s.coloader,
            rep:s.rep,
            stuffing_cutoff:s.stuffing_cutoff
        },
      });
      const {
    control,
    watch,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
    getFieldState,
    getValues,
  } = cargoForm;
  const pod = watch("pod")
  const fpod = watch("fpod")
  const coloader = watch("coloader")
  const carrier = watch("carrier")
  const formValues = watch();
  const [list, setList] = useState([])
  const [carrierlist, setcarrierList] = useState([])
  useEffect(() => {
    if(editStore.contract.shipmentType.indexOf("LCL") >= 0){
      if(coloader == "" || !isArray(coloader)){
    let k = []
      if (coloader == ""){
        k = JSON.parse(JSON.stringify(selectedConsolidatorList))
        setValue("coloader",k);
    }else{
        let l = coloader.split(",")
        k = []
        for (let i = 0; i < selectedConsolidatorList.length; i++) {
          for (let j = 0; j < l.length; j++) {
            if(l[j]==selectedConsolidatorList[i]['scacCode']){
              k.push(selectedConsolidatorList[i])
            }
          }
        }
        setValue("coloader",k);
    }
    multiSelectListStore.selectList[consolidatorListKey] =
        selectedConsolidatorList.map(({ consolidatorAbbrName,scacCode }) => ({
          id: consolidatorAbbrName,
          name: consolidatorAbbrName,
          scacCode:scacCode,
          checked: k
            .map((addedConsolidator) => addedConsolidator.consolidatorAbbrName)
            .includes(consolidatorAbbrName),
        }));
    }
    }else{
      if(coloader!=""){
        setValue("coloader","");
      }
    }
  }, [coloader,editStore.contract]);

  useEffect(() => {
    if(editStore.contract.shipmentType.indexOf("LCL") == -1){
       if(dataListStore["FCLCarrierList"].length==0){
        Api.getFCLCarrierList();
        }else{
          let l = []
          dataListStore["FCLCarrierList"].map((c) => (
            l.push({
                    label: `${c["Display Name"]} (${c["SCAC code"]})`,
                    value: `${c["SCAC code"]}`
                  })
          ))
          if(JSON.stringify(l)!=JSON.stringify(carrierlist)){
            setcarrierList(l)
          }
        }
    }else{
      if(carrier!=process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE){
        setValue("carrier",process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE);
      }
    }
  }, [carrier,editStore.contract,dataListStore["FCLCarrierList"]]);
  useEffect(()=>{
    let l = [
      {
                        lable: "POR",
                        type: "text",
                        name: "por",
                        rules:{ },
                        disabled:true
                    },
                    {
                        lable: "POL",
                        type: "text",
                        name: "pol",
                        rules:{ },
                        disabled:true
                    },
                    {
                        lable: "Routing",
                        type: "text",
                        name: "rep",
                        rules:{ },
                        disabled:true
                    },
                    {
                        lable: "POD",
                        type: "text",
                        name: "pod",
                        rules:{ },
                        disabled:true
                    },
                    {
                        lable: "FPOD",
                        type: "text",
                        name: "fpod",
                        rules:{ },
                        disabled:true
                    },
                    {
                        lable: "Vessel Name",
                        type: "text",
                        name: "vesselname",
                        rules:{ },
                        disabled:false
                    },
                    {
                        lable: "Voyage",
                        type: "text",
                        name: "voyage",
                        rules:{},
                        disabled:false
                    },
                    {
                        lable: "Transit Time",
                        type: "number",
                        name: "transittime",
                        rules:{},
                        disabled:false
                    },
                    {
                        lable: "Stuffing Cut-Off",
                        type: "datetime-local",
                        name: "stuffing_cutoff",
                        rules:{  },
                        disabled:false
                    },
                    {
                        lable: "Cut-Off POR",
                        type: "date",
                        name: "cutoffpor",
                        rules:{  },
                        disabled:false
                    },
                    {
                        lable: "ETD@POL",
                        type: "date",
                        name: "etdpol",
                        rules:{},
                        disabled:false
                    },
                    {
                        lable: "ETA@POD",
                        type: "date",
                        name: "etapod",
                        rules:{ },
                        disabled:false
                    }
                    ]
      if(pod!=fpod){
        l.push({
                        lable: "ETA@FPOD",
                        type: "date",
                        name: "etafpod",
                        rules:{  },
                        disabled:false
                    })
      }
      if(JSON.stringify(list)!=JSON.stringify(l)){
        setList(l)
      }
  },[pod,fpod])
const onSubmit = (data) => {

  let coloader = []
  if(isArray(data.coloader)){
    for (let i = 0; i < data.coloader.length; i++) {
      coloader.push(data.coloader[i]['scacCode'])
    }
    coloader = coloader.join(',')
  }
    s.por=data.por
    s.pol=data.pol
    s.pod=data.pod
    s.fpod=data.fpod
    s.cutoffpor=data.cutoffpor
    s.etdpol=data.etdpol
    s.etapod=data.etapod
    s.etafpod=data.etafpod
    s.vesselname=data.vesselname
    s.voyage=data.voyage
    s.carrier=data.carrier
    s.transittime=data.transittime
    s.coloader=coloader
    s.rep = data.rep
    s.stuffing_cutoff = data.stuffing_cutoff
    let sc = {}
    if(editStore.contract.shipmentType.indexOf("LCL") >= 0){
        sc={
                "POR (CFS / ICD / PORT)": data.por,
                "POL": data.pol,
                "POD UNLOC": Utils.getUNCodeFromLocationString(data.pod),
                "ETD (POL)": data.etdpol,
                "ETA (POD)": data.etapod,
                "VESSEL NAME": data.vesselname,
                "VOYAGE": data.voyage,
                "CARRIER": data.carrier,
                "CO-LOADER": coloader,
                "por": data.por,
                "pol": data.pol,
                "rep": null,
                "pod": data.pod,
                "fpod": data.fpod,
                "cutoffpor": data.cutoffpor,
                "etdpol": data.etdpol,
                "etdrw": 0,
                "etarw": 0,
                "etapod": data.etapod,
                "etafpod": data.etafpod,
                "transitTime": data.transittime,
                "rep":data.rep,
                "STUFFING CUT OFF DATE":data.stuffing_cutoff
            }
        
    }else{
        sc={
                "cutoffpor": data.cutoffpor,
                "etdpor": 0,
                "etdpol": data.etdpol,
                "etapod": data.etapod,
                "etdpod": 0,
                "etafpod": data.etafpod,
                "CARRIER": data.carrier,
                "por": data.por,
                "pol": data.pol,
                "pod": data.pod,
                "fpod": data.fpod,
                "oetd": data.etdpol,
                "deta": data.etapod,
                "v1name": data.vesselname,
                "s1voy": data.voyage,
                "r1code": "",
                "transitTime": data.transittime,
                "ts1code": "",
                "ts2code": "",
                "cscac": data.carrier,
                "CO-LOADER":coloader
            }
        
    }
    if(routes[editStore.subscript]['dummyContract']['schedules']==undefined){
      routes[editStore.subscript]['dummyContract']['schedules'] = [sc]
    }else{
      let b = []
      b.push(sc)
      for (let i = 0; i < routes[editStore.subscript]['dummyContract']['schedules'].length; i++) {
        if(editStore.schind!=i){
          b.push(routes[editStore.subscript]['dummyContract']['schedules'][i])
        }
      }
      routes[editStore.subscript]['dummyContract']['schedules'] = b
    }
    if(data.carrier.length>0){
      routes[editStore.subscript]['dummyContract']['scac'] = data.carrier
    }
    let a = []
    a.push(routes[editStore.subscript])
    for (let i = 0; i < routes.length; i++) {
      if(i!=editStore.subscript){
        a.push(routes[i])
      }
    }
    editStore.routes = JSON.parse(JSON.stringify(a))
    editStore.saveschedule = true
    setOpenScheduleModel(false)
    
}

const getvaild = (name) =>{
      if(formValues[name]==undefined || formValues[name].length==0){
          return true
      }else{
        let k = Utils.getUNCodeFromLocationString(formValues[name])
        if((k.length == 5 && /^[A-Z]+$/.test(k))){
          return true
        }else{
          return false
        }
      }
  }

    return(
        <>
        <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="columns is-vcentered is-multiline qoutecard">
                {list.map((e) => {
                    return (
                        <>
                        {((editStore.contract.shipmentType.indexOf("LCL") >= 0)||(editStore.contract.shipmentType.indexOf("LCL") == -1 && e.name!="rep"))?<div className="column is-3">
                        <LabeledTextField
                            labelStyle={{
                            fontSize: "12px",
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            fontWeight: "bold",
                            }}
                            label={e.lable}
                            control={control}
                            name={e.name}
                            type={e.type}
                            size="small"
                            fullWidth
                            rules={e.rules}
                            disabled={e.disabled}
                        />
                        </div>:""}
                        </>
                    );
                    })}
                    {
                      (editStore.contract.shipmentType.indexOf("LCL") >= 0)?<div className="column is-3">   
                      <AgMultiSelectWithCheckBoxes
                  label={"Consolidator"}
                  storeKey={consolidatorListKey}
                  callback={() => {
                    setValue("coloader",
                      multiSelectListStore.selectList[consolidatorListKey]
                        .filter(({ checked }) => checked)
                        .map(({ id }) =>
                          selectedConsolidatorList.find(
                            ({ consolidatorAbbrName }) =>
                              consolidatorAbbrName === id
                          )
                        ))
                  }}
                  withAllShortcut></AgMultiSelectWithCheckBoxes>
                </div>:<div className="column is-3">
                                <AgSelectNewCH
                                  label="Carrier"
                                  name="carrier"
                                  dataList={carrierlist}
                                  callback={(e1) => {
                                    setValue(`carrier`, e1);
                                  }}
                                  value={carrier}
                                />
                              </div>
                    }
            </div>
            <div className="columns is-vcentered is-multiline">
<div className="column is-12" style={{textAlign:"right"}}>
    <div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div className="control">
                      <button
                        className="button"
                        style={{
                          backgroundColor:
                            process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          const isValid = await trigger();
                      if (isValid) {
                        handleSubmit(onSubmit)();
                      } else {
                        configStore.setModalMessage(`Please check the fields`);
                      }
                        }}
                      >
                        Save
                      </button>
                    </div>
                    <div className="control">
                      <button
                        class="button is-danger"
                        onClick={() => {
                          setOpenScheduleModel(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
</div>
            </div>
        </div>
        </>
    )
}